import axios from 'axios';

import { isEmpty } from 'ramda';
import {
  RECEIVE_SETTINGS,
  OPEN_POPUP,
  CLOSE_POPUP,
  UPDATE_MASTER_NICK_NAME,
  UPDATE_MASTER_NICK_NAME_SUCCESS,
  UPDATE_MASTER_NICK_NAME_ERROR,
  RESET_MASTER_NICK_NAME_ERROR,
  ERROR_POPUP_KEY,
  SUCCESS_POPUP_KEY,
  FETCH_SEB_DATA,
  UPDATE_PERSONAL_DATA,
} from './constants';

export function receiveSettings(data) {
  return {
    type: RECEIVE_SETTINGS,
    data,
  };
}

export const fetchSettings = () => (dispatch) => {
  axios.get('/api/profile/common/settings/')
    .then(({ data }) => {
      if (data.personalData) {
        const {
          needToUpdate,
          personalDataRequired,
          updateIsAllowed,
        } = data.personalData;

        /**
         * Нужно показывать пунк в случае, если соблюдены 2 условия:
         * 1) updateIsAllowed = true
         * 2) любой из признаков needToUpdate или  personalDataRequired  тоже  true (или оба).
         */
        if (updateIsAllowed && (needToUpdate || personalDataRequired)) {
          data.mainNavigation.push({
            path: '/personal-data',
            page: 'PersonalData',
            title: 'Персональные данные',
          });
        }
      }

      dispatch(receiveSettings(data));
    });
};

export const fetchContract = (setError) => () => {
  axios.get('/api/profile/userInfo/contractData', { responseType: 'blob' })
    .then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute(
        'download',
        'contract.pdf',
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(() => {
      setError(true);
    });
};

const updatePersonalData = () => (dispatch) => {
  axios.get('/api/profile/personalData/info/')
    .then(({ data }) => {
      dispatch({
        type: UPDATE_PERSONAL_DATA,
        data,
      });
    });
};

export const openPopup = (key) => ({
  type: OPEN_POPUP,
  key,
});

export const closePopup = () => ({
  type: CLOSE_POPUP,
});

export const openStatusPopup = (key, {
  messageAsTranslationKey = true,
  keepPreviousPopupOpened = true,
  message,
  vars,
} = {}) => (dispatch, getState) => {
  const openedPopup = getState().application.popup;

  dispatch(openPopup({
    messageAsTranslationKey,
    keepPreviousPopupOpened,
    openedPopup,
    message,
    vars,
    key,
  }));
};

export const closeStatusPopup = () => (dispatch, getState) => {
  const {
    openedPopup,
    keepPreviousPopupOpened,
  } = getState().application.popup;

  dispatch(keepPreviousPopupOpened
    ? openPopup(openedPopup)
    : closePopup());
};

export const openErrorPopup = (data) => (dispatch) => {
  dispatch(openStatusPopup(ERROR_POPUP_KEY, data));
};

export const closeErrorPopup = () => (dispatch) => {
  dispatch(closeStatusPopup());
};

export const openSuccessPopup = (data) => (dispatch) => {
  dispatch(openStatusPopup(SUCCESS_POPUP_KEY, data));
};

export const closeSuccessPopup = () => (dispatch) => {
  dispatch(closeStatusPopup());
};

export const updateMasterNickNameStart = () => ({
  type: UPDATE_MASTER_NICK_NAME,
});

export const updateMasterNickNameSuccess = (data) => ({
  data,
  type: UPDATE_MASTER_NICK_NAME_SUCCESS,
});

export const handleUpdatingMasterNickNameError = (error) => ({
  error,
  type: UPDATE_MASTER_NICK_NAME_ERROR,
});

export const updateMasterNickNameError = (error) => (dispatch) => {
  dispatch(handleUpdatingMasterNickNameError(error));
  dispatch(openErrorPopup());
};

export const resetMasterNickNameError = () => ({
  type: RESET_MASTER_NICK_NAME_ERROR,
});

export const updateMasterNickName = (nickName) => async (dispatch, getState) => {
  const linkedAccountLogin = getState().application.settings.masterLogin;

  dispatch(updateMasterNickNameStart());

  try {
    const { data: { isSuccess, errorMessage } } = await axios.post('/api/profile/settings/sso/associatedctnaccount/', {
      linkedAccountLogin,
      nickName,
    });

    if (isSuccess) {
      dispatch(updateMasterNickNameSuccess(nickName));
    } else {
      dispatch(updateMasterNickNameError(errorMessage));
    }
  } catch (error) {
    dispatch(updateMasterNickNameError(error));
  }
};

export const fetchInitialData = () => async (dispatch) => {
  dispatch(fetchSettings());
};

export const fetchPersonalData = () => async (dispatch) => {
  dispatch(updatePersonalData());
};

export const getSeb = () => async (dispatch) => {
  await axios.get('/customers/products/mobile/profile/seb/').then(({ data }) => {
    if (!isEmpty(data)) {
      dispatch({ type: FETCH_SEB_DATA, data });
    }
  }).catch((error) => (
    console.warn(Error(`ERROR: Ошибка в запросе seb - ${error}`))
  ));
};
